import React, { useContext,useState } from "react";
import { Col, Container, Row, Button } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import StatusVehicule from "../components/statistique/statusVehicules";
import InspectionType from "../components/statistique/inspectionType";
import InspectionTypeRapporter from "../components/statistique/TypeInspectionRapporter";
import InspectionIcidentVehicle from "../components/statistique/InspectionIcidentVehicle";
import CardStatistique from "../components/statistique/cardStatistiques";
import calendrier from '../../../assets/images/calendrier.png'; 
import groupIcon from '../../../assets/images/Group 4649.png'; 
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useTranslation } from "react-i18next";

const HomeComponent = () => {
  const history = useContext(HistoryContext);
  document.title = `Tableau de bord | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const toggleCalendar = () => {
    setShowCalendar(!showCalendar); 
  };
  const [showCalendar, setShowCalendar] = useState(false);
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
const [t]=useTranslation();
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb page={t("dashboard.dashboard")} history={history} />
        <Row>
       <Col style={{color:'#252525', fontWeight:'bold',fontSize:'31px',fontFamily:'Raleway'}}>{t("dashboard.dashboard")}</Col>
       </Row>
       <Row> 
  <Col style={{color:'#ADADAD', fontWeight:'500', fontSize:'14px', fontFamily:'Inter'}}>
    {t("dashboard.formattedDate", { date: formattedDate })}
  </Col>
</Row>

        <Row>
          <Col lg={8}>
            <InspectionIcidentVehicle />
          </Col>
          <Col lg={4}>
            <StatusVehicule />
          </Col>
        </Row>
        <Row>
        <Col lg={12}>
            <CardStatistique/>
        </Col>
        </Row>
        
        <Row>
          <Col lg={5}>
            <InspectionType />
          </Col>
          <Col lg={7}>
            <InspectionTypeRapporter />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HomeComponent;
